import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import {
  type AccommodationsPageType,
  mapDtoToAccommodationsBadgeTypes,
  mapDtoToAccommodationsPage,
  mapDtoToAccommodationsPoints,
  mapDtoToAccommodationsTypes,
} from "../model";
import type {
  AccommodationsBadgeType,
  AccommodationsPoints,
  AccommodationsType,
} from "../model/types";
import { searchParams } from "./params";

type DataType = {
  hero: AccommodationsPageType;
  list: AccommodationsPoints;
  filters: AccommodationsType[];
  badges: AccommodationsBadgeType[];
};

export const getAccommodationsPage = async () => {
  const accommodationsPage = strapiClient.single("accommodations-page");
  const accommodationsPoints = strapiClient.collection("accommodations-points");
  const accommodationsTypes = strapiClient.collection("accommodations-types");
  const accommodationsBadgeTypes = strapiClient.collection(
    "accommodations-badge-types",
  );

  const page = await accommodationsPage.find({
    ...searchParams.page,
  });

  const points = await accommodationsPoints.find({
    ...searchParams.points,
  });

  const types = await accommodationsTypes.find({
    ...searchParams.types,
  });

  const badges = await accommodationsBadgeTypes.find({
    ...searchParams.types,
  });

  return rebuild({
    hero: mapDtoToAccommodationsPage(page),
    list: mapDtoToAccommodationsPoints(points),
    filters: mapDtoToAccommodationsTypes(types),
    badges: mapDtoToAccommodationsBadgeTypes(badges),
    seo: page?.data?.seo || {},
  }) as DataType;
};
